import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule } from '@angular/forms';
import { ChartsModule } from 'ng2-charts';
import { CalendarModule } from 'primeng/primeng';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';

import { DashboardRoutingModule } from './dashboard-routing.module';
import { DashboardListComponent } from './dashboard-list/dashboard-list.component';
import { DashboardForItComponent } from './dashboard-for-it/dashboard-for-it.component';
import { DashboardDownloadStatComponent } from './dashboard-download-stat/dashboard-download-stat.component';
import { DashboardSmsComponent } from './dashboard-sms/dashboard-sms.component';

@NgModule({
  imports: [
    CommonModule,
    DashboardRoutingModule,
    DropdownModule,
    FormsModule,
    CalendarModule,
    NgbDropdownModule,
    ChartsModule
  ],
  declarations: [
    DashboardListComponent,
    DashboardForItComponent,
    DashboardDownloadStatComponent,
    DashboardSmsComponent
  ]
})
export class DashboardModule {}



// WEBPACK FOOTER //
// /opt/app/src/app/features/dashboard/dashboard.module.ts